module.exports = __webpack_public_path__ + "img/Speaker=Cindy Fang.0c1a8f3c.png";